import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null, this.p('sync') ? h("d2-bar-cell", [this.syncButton()]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'USER_BLACKLIST_ALL',
        delete: 'USER_BLACKLIST_DELETE',
        sync: 'USER_BLACKLIST_SYNC'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: '',
        sync: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_id'),
        minWidth: '110px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id ? row.market_id : 0,
              "custom": true
            }
          });
        }
      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        width: '120px'
      }, {
        prop: 'status',
        label: 'status',
        width: '160px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "user_black_status",
              "value": row.status
            }
          });
        }
      }, {
        prop: 'user_type',
        label: this.$t('user_type'),
        width: '160px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("d2-dict", {
            "attrs": {
              "name": "black_user_type",
              "value": row.user_type
            }
          });
        }
      }, {
        prop: 'remarks',
        label: this.$t('remarks'),
        width: '120px'
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref4) {
        var row = _ref4.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: 'market_id',
        default: utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this3.search.form.model.market_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'market_mobile',
        label: 'market_mobile',
        default: utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'user_mobile',
        label: 'user_mobile',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.user_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        label: 'status',
        default: '',
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "user_black_status",
              "custom": true,
              "clearable": true
            },
            "style": "width:170px;",
            "model": {
              value: _this3.search.form.model.status,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goOrderBoxData: function goOrderBoxData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-box';
      });
      this.$router.push({
        name: 'management-wash-order-box',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderClothData: function goOrderClothData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-cloth';
      });
      this.$router.push({
        name: 'management-wash-order-cloth',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPayData: function goOrderPayData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-pay';
      });
      this.$router.push({
        name: 'management-wash-order-pay',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderPreferData: function goOrderPreferData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-order-prefer';
      });
      this.$router.push({
        name: 'management-wash-order-prefer',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderAdminRecordData: function goOrderAdminRecordData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-admin-record';
      });
      this.$router.push({
        name: 'management-wash-admin-record',
        query: {
          wash_id: wash_id
        }
      });
    },
    goOrderDeviceRecordData: function goOrderDeviceRecordData(wash_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-box-switch-record';
      });
      this.$router.push({
        name: 'management-wash-box-switch-record',
        query: {
          wash_id: wash_id
        }
      });
    },
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    },
    sync1: function sync1() {
      // alert(0)
      this.sync({
        'market_id': utils.cookies.get('market_id'),
        'optype': 'all'
      });
    },
    syncconfirm: function syncconfirm(confirm, callback) {
      this.$confirm(confirm, 'info', {
        confirmButtonText: 'submit',
        cancelButtonText: 'cancel'
      }).then(callback).catch(function () {});
    },
    syncButton: function syncButton() {
      var _this4 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "type": "danger",
          "icon": "el-icon-upload2",
          "label": "sync black list"
        },
        "on": {
          "click": function click() {
            return _this4.syncconfirm('confirm sync black', _this4.sync1);
          }
        }
      });
      return node;
    }
  })
};